import Alert from './alert';
import FooterLegacy from './footer-legacy';
import Form from './form';
import Modal from './modal';
import PricingCalculator from './pricing-calculator';
import ProductCard from './product-card';

class AEMBaseHandler {
  constructor(component, event, data) {
    this.component = component;
    this.event = event;
    this.data = data;
  }

  translate() {
    let translatedDataObject = {};
    switch (this.component) {
      case 'alert':
      {
        const alert = new Alert(this.event, this.data);
        translatedDataObject = {
          google: alert.googleFormat(),
        };
        break;
      }

      case 'footerLegacy':
      {
        const footerLegacy = new FooterLegacy(this.event, this.data);
        translatedDataObject = {
          google: footerLegacy.googleFormat(),
        };
        break;
      }

      case 'form':
      {
        const form = new Form(this.event, this.data);
        translatedDataObject = {
          google: form.googleFormat(),
        };
        break;
      }

      case 'modal':
      {
        const modal = new Modal(this.event, this.data);
        translatedDataObject = {
          google: modal.googleFormat(),
        };
        break;
      }

      case 'pricingCalculator':
      {
        const pricingCalculator = new PricingCalculator(this.event, this.data);
        translatedDataObject = {
          google: pricingCalculator.googleFormat(),
        };
        break;
      }

      case 'productCard':
      {
        const productCard = new ProductCard(this.event, this.data);
        translatedDataObject = {
          google: productCard.googleFormat(),
        };
        break;
      }

      default:
        throw Error(`Component ${this.component} is not registered`);
    }
    return translatedDataObject;
  }
}

export default AEMBaseHandler;
